import { Card, Loader } from "@caprikorn/dynamo-ui";
import { classNames } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { InfoItem } from "@components/InfoItem/InfoItem";
import type { InfoItemProps } from "@components/InfoItem/InfoItem.types";

import classes from "./InfosCard.module.css";
import type { InfosCardProps } from "./InfosCard.types";

export const InfosCard: FC<InfosCardProps> = ({
  className,
  children,
  dataTestId,
  icon: Icon,
  action,
  title = "",
  data,
  loading = true,
}) => {
  if (!loading && !data) {
    // This allow the box to disappear from DOM if there is nothing to show after loading
    return null;
  }

  const filteredData = data && (data?.filter(Boolean) as InfoItemProps[]);

  return (
    <Card
      className={classNames(className, classes.card)}
      data-testid={dataTestId ? `${dataTestId}-TitledCard` : "TitledCard"}
    >
      {loading ? (
        <Loader />
      ) : (
        <div className={classes.container}>
          <div className={classes.header}>
            <div className={classes.title}>
              {Icon && Icon}
              <h2 className="font-title-sm">{title}</h2>
            </div>
            {action}
          </div>

          {children}

          {filteredData && (
            <ul>
              {filteredData.map((item) => (
                <InfoItem
                  key={item.name}
                  isEmail={item.name.includes("Email")}
                  link={item.name.includes("Email")}
                  name={item.name}
                  value={item.value}
                />
              ))}
            </ul>
          )}
        </div>
      )}
    </Card>
  );
};
